import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["viewAccountCard", "viewTitle", "viewAccountCardBody", "previewCard", "previewTitle", "principalShow",
                    "contactShow", "principalTab", "infoTab", "contactTab", "profileTab", "permissionsTab",
                    "viewPatientCardFooter", "infoShow", "profileShow", "permissionsShow", "subdomainsShow"]

  connect() {
    this.controllerName = `users--accounts--entities--show`
    this.showAccount = false
    this.doViewHtml()
  }

  doViewHtml() {
    var html = `<div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="viewAccountCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4 py-3" style="font-size:110%;margin-bottom:0px;" data-${this.controllerName}-target="viewTitle">Nenhuma Conta Selecionada</h6>
                  </div>
                  <div class="card-body py-0 px-2" style="overflow:auto;" data-${this.controllerName}-target="viewAccountCardBody"></div>
                </div>`

    // this.getControllerByIdentifier("users--accounts--entities--dashboard").viewTarget.innerHTML = html
    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("users--accounts--entities--dashboard").viewTarget.innerHTML = html)
    }).then(() => {
      if (controller.showAccount) {
        controller.doAccountHtml()
      }
    })
  }

  doAccountHtml() {
    var html = `<ul class="nav nav-justified nav-tabs" role="tablist">
                  <li class="nav-item" data-${this.controllerName}-target="principalTab">
                    <a data-action="click->${this.controllerName}#showPrincipal" aria-controls="principal" aria-selected="true" class="f-065 nav-link nav-dark px-0 active" data-toggle="tab" href="#principal" id="principal-tab" role="tab">
                      <span class="mc-tooltip mx-0">
                        <span class="material-icons md-sm mx-0">account_box</span>
                        <span class="mc-tooltiptext mc-tooltiptext-bottom">Principal</span>
                      </span>
                    </a>
                  </li>
                  <li class="nav-item" data-${this.controllerName}-target="infoTab">
                    <a data-action="click->${this.controllerName}#showInfo" aria-controls="info" aria-selected="true" class="f-065 nav-link nav-dark px-0" data-toggle="tab" href="#info" id="info-tab" role="tab">
                      <span class="mc-tooltip mx-0">
                        <span class="material-icons md-sm mx-0">badge</span>
                        <span class="mc-tooltiptext mc-tooltiptext-bottom">Informações</span>
                      </span>
                    </a>
                  </li>
                  <li class="nav-item" data-${this.controllerName}-target="contactTab">
                    <a data-action="click->${this.controllerName}#showContact" aria-controls="contact" aria-selected="true" class="f-065 nav-link nav-dark px-0" data-toggle="tab" href="#contact" id="contact-tab" role="tab">
                      <span class="mc-tooltip mx-0">
                        <span class="material-icons md-sm mx-0">import_contacts</span>
                        <span class="mc-tooltiptext mc-tooltiptext-bottom">Contatos</span>
                      </span>
                    </a>
                  </li>
                  <li class="nav-item" data-${this.controllerName}-target="profileTab">
                    <a data-action="click->${this.controllerName}#showProfile" aria-controls="profile" aria-selected="true" class="f-065 nav-link nav-dark px-0" data-toggle="tab" href="#profile" id="profile-tab" role="tab">
                      <span class="mc-tooltip mx-0">
                        <span class="material-icons md-sm mx-0">manage_accounts</span>
                        <span class="mc-tooltiptext mc-tooltiptext-bottom">Perfil</span>
                      </span>
                    </a>
                  </li>
                  <li class="nav-item" data-${this.controllerName}-target="permissionsTab">
                    <a data-action="click->${this.controllerName}#showPermissions" aria-controls="permissions" aria-selected="true" class="f-065 nav-link nav-dark px-0" data-toggle="tab" href="#permissions" id="permissions-tab" role="tab">
                      <span class="mc-tooltip mx-0">
                        <span class="material-icons md-sm mx-0">policy</span>
                        <span class="mc-tooltiptext mc-tooltiptext-bottom">Permissões</span>
                      </span>
                    </a>
                  </li>
                  <li class="nav-item" data-${this.controllerName}-target="subdomainsTab">
                    <a data-action="click->${this.controllerName}#showSubdomains" aria-controls="subdomains" aria-selected="true" class="f-065 nav-link nav-dark px-0" data-toggle="tab" href="#subdomains" id="subdomains-tab" role="tab">
                      <span class="mc-tooltip mx-0">
                        <span class="material-icons md-sm mx-0">policy</span>
                        <span class="mc-tooltiptext mc-tooltiptext-bottom">Domínios</span>
                      </span>
                    </a>
                  </li>
                </ul>
                <div class="tab-content">
                  <div aria-labelledby="principal-tab" class="tab-pane fade show active" role="tabpanel" id="principal"><div class="list-group" data-${this.controllerName}-target="principalShow"></div></div>
                  <div aria-labelledby="info-tab" class="tab-pane fade" role="tabpanel" id="info"><div class="list-group" data-${this.controllerName}-target="infoShow"></div></div>
                  <div aria-labelledby="contact-tab" class="tab-pane fade" role="tabpanel" id="contact"><div class="list-group" data-${this.controllerName}-target="contactShow"></div></div>
                  <div aria-labelledby="profile-tab" class="tab-pane fade" role="tabpanel" id="profile"><div class="list-group" data-${this.controllerName}-target="profileShow"></div></div>
                  <div aria-labelledby="permissions-tab" class="tab-pane fade" role="tabpanel" id="permissions"><div class="list-group" data-${this.controllerName}-target="permissionsShow"></div></div>
                  <div aria-labelledby="subdomains-tab" class="tab-pane fade" role="tabpanel" id="subdomains"><div class="list-group" data-${this.controllerName}-target="subdomainsShow"></div></div>
                </div>`

    this.viewTitleTarget.innerText = this.current_account.name
    var controller = this
    new Promise(function (resolve) {
      resolve(controller.viewAccountCardBodyTarget.innerHTML = html)
    }).then(() => {
      controller.viewAccountCardTarget.style.height = ($(window).height() * 0.55) + "px"
      controller.showPrincipal()
      if (!controller.application.permissions.account_entity_infos.can_index) {
        controller.infoTabTarget.children[0].classList.add("disabled")
      }
      if (!controller.application.permissions.account_entity_contacts.can_index) {
        controller.contactTabTarget.children[0].classList.add("disabled")
      }
      if (!controller.application.permissions.account_entity_profiles.can_index) {
        controller.profileTabTarget.children[0].classList.add("disabled")
      }
      if (!controller.application.permissions.account_entity_permissions.can_index) {
        controller.permissionsTabTarget.children[0].classList.add("disabled")
      }
      if (!controller.application.permissions.account_entity_permissions.can_index) {
        controller.subdomainsTabTarget.children[0].classList.add("disabled")
      }
    })
  }

  showPrincipal() {
    var html = `<div data-controller="users--accounts--entities--principal" data-users--accounts--entities--principal-target="main" data-kind="${this.kind}"></div>`
    $(".nav-tabs-indicator").addClass("nav-dark")
    this.principalShowTarget.innerHTML = html
  }

  showInfo() {
    var html = `<div data-controller="users--accounts--documents--info" data-users--accounts--documents--info-target="main"></div>`
    if (this.application.permissions.account_entity_infos.can_index) {
      $(".nav-tabs-indicator").addClass("nav-dark")

      var controller = this
      new Promise(function (resolve) {
        resolve(controller.infoShowTarget.innerHTML = html)
      }).then(() => {
        this.getControllerByIdentifier(`users--accounts--documents--info`).current_account = this.current_account
        this.getControllerByIdentifier(`users--accounts--documents--info`).permission = `account_entity_infos`
        this.getControllerByIdentifier(`users--accounts--documents--info`).setCurrentInfo()
      })
    }
  }

  showContact() {
    var html = `<div data-controller="users--accounts--entities--contact" data-users--accounts--entities--contact-target="main"></div>`
    if (this.application.permissions.account_entity_contacts.can_index) {
      $(".nav-tabs-indicator").addClass("nav-dark")
      this.contactShowTarget.innerHTML = html
    }
  }

  showProfile() {
    var html = `<div data-controller="users--accounts--entities--profile" data-users--accounts--entities--profile-target="main"></div>`
    if (this.application.permissions.account_entity_profiles.can_index) {
      $(".nav-tabs-indicator").addClass("nav-dark")
      this.profileShowTarget.innerHTML = html
    }
  }

  showPermissions() {
    var html = `<div data-controller="users--accounts--entities--permissions" data-users--accounts--entities--permissions-target="main"></div>`
    // if (this.application.permissions.account_entity_permissions.can_index && this.current_account.user_id != undefined) {
    if (this.application.permissions.account_entity_permissions.can_index && (this.application.current_user.super_admin || this.current_account.id != this.application.current_user.account_id)) {
      $(".nav-tabs-indicator").addClass("nav-dark")
      this.permissionsShowTarget.innerHTML = html
    }
  }

  showSubdomains() {
    var html = `<div data-controller="users--accounts--entities--subdomains" data-users--accounts--entities--subdomains-target="main"></div>`
    if (this.application.permissions.account_entity_permissions.can_index && (this.application.current_user.super_admin || this.current_account.id != this.application.current_user.account_id)) {
      $(".nav-tabs-indicator").addClass("nav-dark")
      this.subdomainsShowTarget.innerHTML = html
    }
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    this.connect()
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
